import Logger from "../Logger";
import { ChannelType } from "../models/ChannelType";
import { getSignalTypeBundle, getSignalTypeBundleWithoutScene } from "../models/SignalBundles";
import { descriptionForSignalType } from "../models/SignalTypes";
import { itx } from "../translationItx/itx";
import AddressGeneratorUtils from "./AddressGeneratorUtils";
import { generateAddressesForMultiplexer } from "./generateAddressesForMultiplexer";

const logger = new Logger();

export function createGlobalAddresses(scheme: string) {
  const mainGroup = AddressGeneratorUtils.getOrCreateGroupAddressByAddress({
    level: 1,
    tag: "ALG", // no itx
    name: state.translate("channelType.General", "Allgemein"),
    address: `31`,
    parent: state.addresses,
  });

  const scenesGroup = AddressGeneratorUtils.getOrCreateGroupAddressByAddress({
    tag: "S",
    name: state.translate("components.plural.Scene", "Szenen"),
    level: 2,
    address: "0",
    parent: mainGroup,
  });

  const sceneAddress = AddressGeneratorUtils.getOrCreateGroupAddressByAddress({
    level: 3,
    tag: "S",
    name: state.translate("createSceneAddresses.sceneTotal", "Szene Gesamt"),
    address: "0",
    parent: scenesGroup,
  });

  ////////////////////////////////////////////////////////////////////////////////
  //
  // Multiplexer
  //

  generateAddressesForMultiplexer(scheme, mainGroup);

  ////////////////////////////////////////////////////////////////////////////////
  //
  // Manual Addresses
  //

  const manualGroup = AddressGeneratorUtils.getOrCreateGroupAddressByAddress({
    tag: "M", // no itx
    name: itx("createGlobalAdresses.manualGroupAdresses", "Manuelle Gruppenadressen"),
    level: 2,
    address: "2",
    parent: mainGroup,
  });

  const logicGroup = AddressGeneratorUtils.getOrCreateGroupAddressByAddress({
    tag: "L", // no itx
    name: itx("createGlobalAdresses.logicStates", "Logic States"),
    level: 2,
    address: "3",
    parent: mainGroup,
  });

  const etsReserved = AddressGeneratorUtils.getOrCreateGroupAddressByAddress({
    tag: "L", // no itx
    name: itx("createGlobalAddresses.reseviertmanuellegruppenadressen", "Reseviert (manuelle Gruppenadressen in ETS)"),
    level: 2,
    address: "5",
    parent: mainGroup,
  });

  ////////////////////////////////////////////////////////////////////////////////

  //
  // Environment MainGroup
  //

  const environmentGroup = AddressGeneratorUtils.getOrCreateGroupAddressByAddress({
    tag: "E", // no itx
    name: state.translate("channelType.Environment", "Environment"),
    level: 2,
    address: "1",
    parent: mainGroup,
  });

  //
  // Create all Environment GroupAddresses
  //

  const environmentBundle = getSignalTypeBundleWithoutScene(ChannelType.Environment); // if not without scene error because ss?.[1] == "1" is not working for scene signalType
  environmentBundle.forEach((signalType) => {
    let description = descriptionForSignalType(signalType);

    const globalGroupAdress = signalType.globalGroupAdress;
    const ss = globalGroupAdress?.split("/");
    const address = ss?.[2];

    if (ss?.[1] == "1" && address) {
      const environmentItem = AddressGeneratorUtils.getOrCreateGroupAddressByAddress({
        level: 3,
        tag: "S",
        name: description,
        address: `${address}`,
        parent: environmentGroup,
      });
    } else {
      logger.error(`invalid signalType: ${signalType.name} no globalGroupAdress `);
    }
  });
}
